export default __webpack_public_path__ + "static/media/Butt_Pain.803ff822.webp";